'use strict';

exports.__esModule = true;
exports.setActionHandler = exports.doAction = exports.setGeneratorActionHandler = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var handlers = {};

var reject = function reject(action) {
  throw Error({
    reason: 'There is no handler for ' + action.type,
    action: action
  });
};

var setGeneratorActionHandler = exports.setGeneratorActionHandler = function setGeneratorActionHandler(type, handler) {
  handlers[type] = handler;
};

var doAction =
/*#__PURE__*/
exports.doAction = _regenerator2.default.mark(function doAction(action) {
  var handler;
  return _regenerator2.default.wrap(function doAction$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          handler = handlers[action.type] || reject;
          return _context.delegateYield(handler(action), 't0', 2);

        case 2:
          return _context.abrupt('return', _context.t0);

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, doAction, this);
});

var setActionHandler = exports.setActionHandler = function setActionHandler(type, handler) {
  setGeneratorActionHandler(type,
  /*#__PURE__*/
  _regenerator2.default.mark(function _callee(action) {
    return _regenerator2.default.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.call)(handler, action);

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee, this);
  }));
};